import { defineAttrs as c } from "../../utils/typed-attrs.js";
const o = c({
  attributePath: { default: "" },
  fallback: { default: "" }
}), p = {
  inline: !0,
  attrs: o,
  group: "inline",
  selectable: !0,
  parseDOM: [
    {
      tag: "span.embercom-prosemirror-composer-template",
      getAttrs(t) {
        return {
          attributePath: t.getAttribute("data-template-identifier"),
          fallback: t.getAttribute("data-template-fallback")
        };
      }
    }
  ],
  toDOM(t) {
    const l = t.attrs, e = l.attributePath, s = l.fallback, a = t.type.spec.infoResolver, i = a?.humanReadable(e), r = ["embercom-prosemirror-composer-template", "intercom-interblocks-template"];
    return a && !a.isValid(e) && r.push("invalid"), a?.requiresFallback(e, s) && r.push("requires-fallback"), [
      "span",
      {
        class: r.join(" "),
        "data-template-identifier": e,
        "data-template-fallback": s
      },
      i
    ];
  }
};
export {
  p as templateSpec
};
